import { render, staticRenderFns } from "./CustomizationMessage.vue?vue&type=template&id=4bb92d6d&scoped=true&"
import script from "./CustomizationMessage.vue?vue&type=script&lang=js&"
export * from "./CustomizationMessage.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationMessage.vue?vue&type=style&index=0&id=4bb92d6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb92d6d",
  null
  
)

export default component.exports